import React, { useContext, useState, useEffect } from 'react';
import { ThemeProvider, ThemeContext, css } from 'styled-components';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
var Provider = function Provider(_ref) {
  var children = _ref.children,
    breakpoints = _ref.breakpoints,
    props = _objectWithoutPropertiesLoose(_ref, ["children", "breakpoints"]);
  return React.createElement(ThemeProvider, {
    theme: _extends({
      breakpoints: breakpoints
    }, props)
  }, children);
};
Provider.defaultProps = {
  breakpoints: {
    xs: {
      width: 0
    },
    sm: {
      width: 480
    },
    md: {
      width: 768
    },
    lg: {
      width: 992
    },
    xl: {
      width: 1280
    }
  }
};
var useTheme = function useTheme() {
  return useContext(ThemeContext);
};
var w = typeof window !== 'undefined';
var getSize = function getSize() {
  return {
    innerHeight: w ? window.innerHeight : 0,
    innerWidth: w ? window.innerWidth : 0
  };
};
var useWindowSize = function useWindowSize() {
  var _useState = useState(getSize),
    windowSize = _useState[0],
    setWindowSize = _useState[1];
  var handleResize = function handleResize() {
    return setWindowSize(getSize);
  };
  useEffect(function () {
    if (!w) return;
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};
var useMediaQuery = function useMediaQuery(_ref) {
  var _ref$above = _ref.above,
    above = _ref$above === void 0 ? 0 : _ref$above,
    _ref$below = _ref.below,
    below = _ref$below === void 0 ? Infinity : _ref$below;
  var theme = useTheme();
  var _useWindowSize = useWindowSize(),
    innerWidth = _useWindowSize.innerWidth;
  var _useState = useState(true),
    visible = _useState[0],
    setVisible = _useState[1];
  var breakpoints = theme.breakpoints;
  var _ref2 = breakpoints[above] || {
      width: above || 0
    },
    aboveWidth = _ref2.width;
  var _ref3 = breakpoints[below] || {
      width: below || 0
    },
    belowWidth = _ref3.width;
  var condition = innerWidth >= aboveWidth && innerWidth < belowWidth;
  useEffect(function () {
    setVisible(condition);
  }, [innerWidth]);
  return visible;
};
var getVisibleBreakpoints = function getVisibleBreakpoints(breakpoints, innerWidth) {
  return Object.keys(breakpoints).filter(function (key) {
    return breakpoints[key].width < innerWidth;
  });
};
var useBreakpoints = function useBreakpoints() {
  var _useState = useState([]),
    state = _useState[0],
    setState = _useState[1];
  var _useWindowSize = useWindowSize(),
    innerWidth = _useWindowSize.innerWidth;
  var theme = useTheme();
  var breakpoints = theme.breakpoints;
  useEffect(function () {
    setState(getVisibleBreakpoints(breakpoints, innerWidth));
  }, [innerWidth]);
  return state;
};
var getCurrent = function getCurrent(breakpoints) {
  return (breakpoints || []).reverse()[0];
};
var useCurrentBreakpoints = function useCurrentBreakpoints() {
  var _useState = useState(),
    state = _useState[0],
    setState = _useState[1];
  var breakpoints = useBreakpoints();
  useEffect(function () {
    setState(getCurrent(breakpoints));
  }, [breakpoints]);
  return state;
};
function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t@media (min-width: ", "px) {\n\t\t", "\n\t}\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var above = function above(label) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return function (props) {
      return css(_templateObject(), props.theme.breakpoints[label].width, css.apply(void 0, args));
    };
  };
};
function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["", ""]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["", ""]);
  _templateObject$1 = function _templateObject() {
    return data;
  };
  return data;
}
var mapTheme = function mapTheme(fn) {
  return function (props) {
    var breakpoints = props.theme.breakpoints;
    return Object.keys(breakpoints).map(function (label) {
      return above(label)(_templateObject$1(), fn(breakpoints[label], props));
    });
  };
};
var mapBreakpoints = function mapBreakpoints(fn) {
  return function (props) {
    var breakpoints = props.theme.breakpoints;
    return Object.keys(props).filter(function (prop) {
      return Object.keys(breakpoints).includes(prop);
    }).map(function (label) {
      return above(label)(_templateObject2(), fn(props[label], props));
    });
  };
};
export { Provider, above, mapBreakpoints, mapTheme, useBreakpoints, useCurrentBreakpoints as useCurrentBreakpoint, useMediaQuery, useTheme, useWindowSize };